// Proposed monthly payment for the Loan & Property card. Principal and interest
// come from the loan terms; other financing is the payments on the URLA's other new
// mortgages; insurance, taxes and mortgage insurance come from the Loan Estimate fees (the escrow monthly figure, else the prepaid one).
// Nothing is guessed: a line with no LE figure is 0 here (the DTI, which needs
// taxes and insurance, refuses to estimate without them).

const num = (v) => Number(v) || 0;
const firstNonZero = (...vals) => vals.map(num).find((v) => v > 0) || 0;

// Payments on every other new mortgage on the subject (second lien, HELOC), any lien type.
export const otherFinancing = (rows) => (rows || []).reduce((s, r) => s + num(r?.monthly_payment), 0);

export function proposedPayment({ loan_amount, note_rate, term_months, le_fees, other_new_mortgages }) {
  const P = num(loan_amount);
  const r = num(note_rate) / 100 / 12;
  const n = num(term_months) || 360;
  const firstMortgage = r > 0 ? (P * r) / (1 - Math.pow(1 + r, -n)) : (P > 0 ? P / n : 0);
  const fees = le_fees || {};
  const hoi = firstNonZero(fees.escrow_hoi_monthly, fees.prepaid_hoi_monthly);
  const taxes = firstNonZero(fees.escrow_property_tax_monthly, fees.prepaid_property_tax_monthly);
  const mi = firstNonZero(fees.escrow_mi_monthly, fees.prepaid_mi_monthly);
  const other = otherFinancing(other_new_mortgages);
  const total = firstMortgage + other + hoi + taxes + mi;
  return { firstMortgage, other, hoi, taxes, mi, total, hasEscrowFigures: hoi + taxes + mi > 0 };
}
